<h1>App Versions</h1>

<div class="card">
  <div class="card-header">
    App Versions
  </div>
  <div class="card-block">
    <div class="table-responsive">
      <div class="loading-cont" *ngIf="loading"><div class="loading-spinner"></div></div>
      <p class="no-items-found" *ngIf="!loading && 0 === items.length">No items found.</p>

      <table class="table table-hover" *ngIf="!loading && 0 < items.length">
        <thead>
          <tr>
            <th>
              <span>App description</span>
            </th>
            <th>
              <span>Current build version</span>
            </th>
            <th>
              <span>Minimal build version</span>
            </th>
            <th>
              <span>Current store version</span>
            </th>
            <th>
              <span>Minimal store version</span>
            </th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items; let i = index">
            <td>
              <span>{{ item.operatingSystem }}</span>
            </td>
            <td>
              <span>{{ item.currentVersion }}</span>
            </td>
            <td>
              <span>{{ item.minimalVersion }}</span>
            </td>
            <td>
              <span>{{ item.currentStoreVersion }}</span>
            </td>
            <td>
              <span>{{ item.minimalStoreVersion }}</span>
            </td>
            <td class="col-md-1">
              <a
              id='appVersionsEdit'class="btn btn-primary" [routerLink]="['/admin/app-versions/edit']" [queryParams]="{ system: item.operatingSystem }">Edit</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div>
  <div class="page-bottom-container action-buttons">
    <ch-pagination
      *ngIf="!loading"
      [totalItems]="totalItems"
      (pageChanged)="onPageChanged($event)"
    ></ch-pagination>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/app-versions/app-versions-listing/app-versions-listing.component.html